
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[mainSubpage]",
      function () {
        return require("private-next-pages/[mainSubpage]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[mainSubpage]"])
      });
    }
  